import {
  LabeledBooleanInput,
  Props as LabeledBooleanInputProps,
} from './LabeledBooleanInput';

type Props = Omit<LabeledBooleanInputProps, 'type'> & {
  /**
   * The content to render for the label
   */
  children: React.ReactNode;

  /**
   * Indicates whether `LabeledRadio` is disabled.
   * @deprecated Use `isDisabled` instead
   */
  disabled?: boolean;

  /**
   * Indicates whether the input is required.
   * @deprecated Individual radio buttons shouldn't be required. To mark a radio group as required, pass `isRequired` to a `FormLabel` associated with `LabeledRadio`.
   */
  isRequired?: boolean;
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ This component is on its way out in favor of [RadioGroup β](../?path=/docs/beta-radio--docs).</span>
 *
 * @deprecated: Use beta `RadioGroup` instead.
 */
export const LabeledRadio = ({ disabled, isDisabled, ...props }: Props) => (
  <LabeledBooleanInput
    {...props}
    isDisabled={disabled || isDisabled}
    type="radio"
  />
);
